import type { Ref } from 'vue'
import type { SourceChainOption, SourceChainType, WalletSourceToken } from './contracts'

export interface SourceTokensApi {
  sourceChainOptions: Readonly<Ref<readonly SourceChainOption[]>>
  selectedChainId: Readonly<Ref<number>>
  selectedTokenAddress: Readonly<Ref<string | undefined>>
  amount: Readonly<Ref<string>>
  chainType: Readonly<Ref<SourceChainType>>
  availableTokens: Readonly<Ref<WalletSourceToken[]>>
  isLoading: Readonly<Ref<boolean>>
  blockedMessage: Readonly<Ref<string | null>>
  selectChain: (chainId: number) => void
  selectToken: (tokenAddress: string, amount: string) => void
  setAmount: (amount: string) => void
}

let installed: SourceTokensApi | null = null

export const installSourceTokens = (api: SourceTokensApi): void => {
  installed = api
}

export const getSourceTokens = (): SourceTokensApi => {
  if (!installed) throw new Error('source_tokens_not_installed')
  return installed
}
